module.exports = __webpack_public_path__ + "img/floor_f1_01.536bac36.png";